import * as React from "react";
import { forwardRef } from "react";
const SvgDashboeadMenuArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 38, height: 38, viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16 25L22 18.9016L16 13", stroke: "#B0B0B0", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDashboeadMenuArrow);
export { ForwardRef as ReactComponent };
